import React, { Component } from "react";
import { Link } from "react-router-dom";

import { classnames, Icon } from "@culturehq/components";

import ExclamationIcon from "components/common/ExclamationIcon";
import { isTarget } from "app/utils";
import OrganizationRow from "./OrganizationRow";
import { TargetQuoteIcon } from "./icons";

class Accordian extends Component {
  constructor(props) {
    super(props);

    const { initialOpen } = props;

    this.state = {
      open: initialOpen
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { onScroll } = this.props;
    const { open } = this.state;

    if (onScroll && open !== prevState.open && open) {
      onScroll();
    }
  }

  handleToggle = () => {
    this.setState(({ open }) => {
      if (open) {
        return { open: false };
      }
      return { open: true };
    });
  };

  handleScroll = event => {
    const { onScroll } = this.props;
    const { target } = event;

    if (onScroll && target.scrollTop + target.offsetHeight + 50 >= target.scrollHeight) {
      onScroll();
    }
  };

  render() {
    const {
      className, icon, title, subtitle, children, organizationsAccordian, titleOpen, sumIcon,
      exclamationIcon, titleLink, upDown, profile, orgName
    } = this.props;
    const { open } = this.state;

    return (
      <div className={classnames("Accordian", "clearfix", open ? "open" : "", className)}>
        <div className="Accordian__container" onClick={this.handleToggle}>
          {organizationsAccordian ? (
            <>
              <OrganizationRow className="SelectedOrganization" organization={profile.organization} />
              {upDown && !sumIcon && <Icon className="Accordian__arrow" icon={open ? "chevron-up" : "chevron-down"} />}
            </>
          ) : (
            <>
              <div className="Accordian__title--icon__container">
                {isTarget(orgName) ? (
                  <TargetQuoteIcon className="TargetQuoteIcon" />
                ) : (
                  <Icon className="Accordian__title--icon" icon={icon} />
                )}
                {exclamationIcon && (
                  <ExclamationIcon className="Accordian__title--icon Accordian__title--icon__exclamation" />
                )}
              </div>
              <div className={isTarget(orgName) ? "Title" : "Accordian__title--container"}>
                <div>
                  {titleLink ? (
                    <Link to={titleLink} tabIndex={0}>
                      {open ? (titleOpen || title) : title}
                    </Link>
                  ) : (
                    <h2 className="Accordian__title no-select clickable">{open ? (titleOpen || title) : title}</h2>
                  )}
                  <h4 className="Accordian__subtitle">{subtitle}</h4>
                </div>
                {!sumIcon && !upDown && <Icon className="Accordian__arrow" icon={open ? "chevron-up" : "chevron-right"} />}
                {upDown && !sumIcon && <Icon className="Accordian__arrow" icon={open ? "chevron-up" : "chevron-down"} />}
                {sumIcon && !upDown && <Icon className="Accordian__arrow" icon={open ? "minus" : "plus"} />}
              </div>
            </>
          )}
        </div>

        <div
          className={classnames("Accordian__body", open ? "open" : "closed")}
          onScroll={this.handleScroll}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Accordian;
